export const ROOT = "/";
export const DASHBOARD = "/dashboard";
export const PAGE_404 = "/404";
export const VERIFYRESETPASSWORD = "/verify-reset-password";
export const VERIFYUSER = "/verify-user";
export const PROFILE = "/profile";
export const APPLY_BATCH = "/daftar";
